// extracted by mini-css-extract-plugin
module.exports = {"danger":"Toast_danger__2A6KB","success":"Toast_success__3cnbw"};